import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  Tooltip,
  IconButton,
  Switch,
  TextField
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { Link } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";

export default class Blogs extends Component {
  state = {
    blogs: [],
    page: 1,
    limit: 10,
    totalPages: 1,
    total: 0,

    notification: false,
    message: "",
    notiColor: "success",
    loading: false,
  };

  componentDidMount() {
    this.getAllBlogs();
  }

  // ✅ FETCH BLOGS (WITH PAGINATION)
  getAllBlogs = () => {
    const { page, limit } = this.state;

    this.setState({ loading: true });

    

    axios
      .post(Constants.getUrls.getBlogList, { page, limit })
      .then((resp) => {
        if (resp.data?.status) {
          const resData = resp.data.data;

          this.setState({
            blogs: resData.rows || [],
            totalPages: resData.pagination.totalPages,
            total: resData.pagination.total,
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            message: resp.data.message,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        
        this.setState({
          notification: true,
          message: "Failed to fetch blogs",
          loading: false,
        });
      });
  };

  // ✅ DELETE BLOG
  handleDelete = (id) => {
    if (!window.confirm("Delete this blog?")) return;

    axios
      .post(Constants.deleteUrls.deleteBlog, { blog_id: id })
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data.message,
        });
        this.getAllBlogs();
      })
      .catch(() => {
        this.setState({
          notification: true,
          message: "Delete failed",
        });
      });
  };

  // ✅ STATUS TOGGLE
  handleStatus = (id, status) => {
    axios
      .post(Constants.putUrls.updateBlogStatus, {
        blog_id: id,
        status: status ? "0" : "1",
      })
      .then(() => this.getAllBlogs())
      .catch(() => {
        this.setState({
          notification: true,
          message: "Status update failed",
        });
      });
  };

  render() {
    const { blogs, loading, page, limit, totalPages } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Blogs List
              </MDTypography>
            </MDBox>

            {/* CREATE BUTTON */}
            <Grid item xs={12} px={2} py={2} textAlign="right">
              <Link to="/addblogs">
                <MDButton variant="contained" color="primary">
                  Create Blog
                </MDButton>
              </Link>
            </Grid>

            {/* TABLE */}
            <MDBox py={2}>
              {loading ? (
                <Grid textAlign="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : blogs.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial" },
                      { Header: "Title", accessor: "title" },
                      { Header: "Image", accessor: "image" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: blogs.map((blog, index) => ({
                      // ✅ SERIAL FIX
                      serial: (page - 1) * limit + index + 1,

                      title: blog.title,

                      image: blog.image_path ? (
                        <img
                          src={
                            Constants.imageDomain + blog.image_path
                          }
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: 6,
                            objectFit: "cover",
                          }}
                        />
                      ) : "-",

                      status: (
                        <Switch
                          checked={blog.status === "1"}
                          onChange={() =>
                            this.handleStatus(
                              blog.id,
                              blog.status === "1"
                            )
                          }
                        />
                      ),

                      action: (
                        <div style={{ display: "flex", gap: 10 }}>
                          <Tooltip title="Edit">
                            <Link to={`/updateblogs/${blog.id}`}>
                              <IconButton color="info">
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete">
                            <IconButton
                              color="error"
                              onClick={() =>
                                this.handleDelete(blog.id)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                />
              ) : (
                <div style={{ padding: 20 }}>No Blogs Found</div>
              )}
            </MDBox>

            {/* PAGINATION */}
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              px={3}
              py={2}
            >
              <MDButton
                variant="outlined"
                disabled={page === 1}
                onClick={() =>
                  this.setState(
                    { page: page - 1 },
                    this.getAllBlogs
                  )
                }
              >
                Prev
              </MDButton>

              <MDTypography>
                Page {page} of {totalPages}
              </MDTypography>

              <MDButton
                variant="outlined"
                disabled={page === totalPages}
                onClick={() =>
                  this.setState(
                    { page: page + 1 },
                    this.getAllBlogs
                  )
                }
              >
                Next
              </MDButton>
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color={this.state.notiColor}
              title="Blogs"
              content={this.state.message}
              open={this.state.notification}
            />

          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}